import getAppInfo from "src/utils/app-Info";

/**
 * 약관 본문 링크
 * Taap/IFC 는 guidelines.taapspace.kr 를 공용으로 사용, STPM 만 별도 약관(Google Docs) 사용
 */

// Taap/IFC 공용 약관
export const TERMS_OF_SERVICE_URL = "https://guidelines.taapspace.kr/3c06b12a-68e6-4275-ab52-ab0f9f080b1a";
export const PRIVACY_POLICY_URL = "https://guidelines.taapspace.kr/30c9aa8e-488a-4661-bd88-2629f120e263";
export const OPERATING_POLICY_URL = "https://guidelines.taapspace.kr/127133c5-cc34-478e-af2c-338774a198e4";
export const PRIVACY_COLLECTION_AND_USE_URL = "https://guidelines.taapspace.kr/36098b25-fe74-80ab-a9d0-c79519d4aafb";

// STPM 전용 약관 (Google Docs)
const STPM_TERMS_OF_SERVICE_URL =
  "https://docs.google.com/document/u/1/d/e/2PACX-1vSW_WAGQOC3Yhm5hH0EHSnKej1dW5ffOBTyEAhUDb9IaXTdbGwwvqe529ocgHaaPL8znOt8YM3xsSo-/pub";
const STPM_PRIVACY_COLLECTION_AND_USE_URL =
  "https://docs.google.com/document/u/1/d/e/2PACX-1vQrBiyr24EkwbSqod5BgbjPe0PyR3U24Zbn7JofFhUp3TzJIxQg0xf7Z2kCvlxULAHpBVSIg1Dh6gS1/pub";
const STPM_PRIVACY_POLICY_URL =
  "https://docs.google.com/document/u/1/d/e/2PACX-1vTVZktwyNx0BrPsE-BgcgSwG1lSbn27qNJ5iMJsnUdTee8UM4ZpWArUsWYjDc7FSSMNm23x78KhuBTM/pub";

/** 현재 서비스(appType)에 맞는 서비스 이용약관 URL */
export const getTermsOfServiceUrl = (): string =>
  getAppInfo().appType === "STPM" ? STPM_TERMS_OF_SERVICE_URL : TERMS_OF_SERVICE_URL;

/** 현재 서비스(appType)에 맞는 개인정보 수집 및 이용 동의 URL */
export const getPrivacyCollectionAndUseUrl = (): string =>
  getAppInfo().appType === "STPM" ? STPM_PRIVACY_COLLECTION_AND_USE_URL : PRIVACY_COLLECTION_AND_USE_URL;

/** 현재 서비스(appType)에 맞는 개인정보 처리방침 URL */
export const getPrivacyPolicyUrl = (): string =>
  getAppInfo().appType === "STPM" ? STPM_PRIVACY_POLICY_URL : PRIVACY_POLICY_URL;
